
































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { EmploymentWagesTableInterface } from '@/components/reports/vedomost/helpers/Vedomost.interface'

@Component
export default class Table extends Vue {
  employmentWagesTable: EmploymentWagesTableInterface[] = []
  col9Sum = 0
  col10Sum = 0
  col11Sum = 0
  col12Sum = 0
  startWorkDate = null
  endWorkDate = null

  @Prop({ type: Object, default: () => ({}) }) tableData

  @Watch('tableData') onChangeTableData(val) {
    this.employmentWagesTable = val.employmentWagesTable
    const { col9Sum, col10Sum, col11Sum, col12Sum, startWorkDate, endWorkDate } = val
    this.col9Sum = col9Sum
    this.col10Sum = col10Sum
    this.col11Sum = col11Sum
    this.col12Sum = col12Sum
    this.startWorkDate = startWorkDate
    this.endWorkDate = endWorkDate
  }

  public addRow(): void {
    this.employmentWagesTable.push({
      col_2: null,
      col_3: null,
      col_4: null,
      col_5: this.startWorkDate,
      col_6: this.endWorkDate,
      col_7: null,
      col_8: null,
      col_9: null,
      col_10: null,
      col_11: null,
      col_12: null,
      col_13: null,
      col_14: null
    })
  }
  public removeRow(val): void {
    this.employmentWagesTable.splice(val, 1)
  }
}
